import Grid from '@/global/components/ui/Grid'
import { CategoriaEnum } from '@acme/auth'
import { FormField, FormFieldSelect } from 'global/components/Form'
import { ExternalLinkIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

export function NovoUsuarioForm() {
    const { watch } = useFormContext()
    const categoriaId = watch('categoriaId')

    return (
        <Grid container>
            <Grid item xs={12}>
                <FormFieldSelect
                    required
                    name="categoriaId"
                    label="Categoria de acesso"
                    options={[
                        { value: CategoriaEnum.Suporte, label: 'Suporte' },
                        {
                            value: CategoriaEnum.Cliente,
                            label: (
                                <span className="flex items-center gap-2">
                                    <ExternalLinkIcon size={14} /> Cliente
                                </span>
                            ),
                        },
                        {
                            value: CategoriaEnum.Avaliacao,
                            label: (
                                <span className="flex items-center gap-2">
                                    <ExternalLinkIcon size={14} /> Avaliação
                                </span>
                            ),
                        },
                        {
                            value: CategoriaEnum.Representante,
                            label: (
                                <span className="flex items-center gap-2">
                                    <ExternalLinkIcon size={14} /> Representante
                                </span>
                            ),
                        },
                    ]}
                />
            </Grid>
            <Grid item xs={12}>
                <FormField name="email" label="Email" required type="email" />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="nome"
                    label="Nome"
                    max={50}
                    autoComplete="off"
                    helperText="Deixe em branco para exibir o nome derivado do cadastro."
                />
            </Grid>
            {categoriaId === CategoriaEnum.Cliente && (
                <Grid item xs={12}>
                    <FormField
                        name="clienteId"
                        label="ID do Cliente"
                        type="number"
                        required
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <FormField
                    name="password"
                    label="Senha"
                    type="password"
                    required
                    autoComplete="new-password"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme a senha"
                    type="password"
                    required
                    autoComplete="new-password"
                />
            </Grid>
        </Grid>
    )
}
